import { css } from 'styled-components';
import { mediaBreakpointMixin } from './mediaBreakpointMixin';

/** @mixin mediaMixin */
/**
 * Adds styles at the given token breakpoint.
 *
 * @example
 * import { css } from 'styled-components';
 * import { mediaMixin } from '@zillow/constellation';
 *
 * const styles = css`
 *     color: red;
 * `;
 *
 * const Component = styled.div`
 *     ${mediaMixin('md', styles)}
 * `;
 *
 * <Component>This text will be red at the "md" breakpoint</Component>
 *
 * @method
 * @param {string} breakpoint - A breakpoint media token. By default, the styles will apply to sizes
 *     greater than or equal (gte) to the the breakpoint value. You can also apply styles at sizes
 *     less than or equal (lte), or exactly equal by appending to the breakpoint,
 *     e.g. sm_lte, md_eq, lg_gte.
 * @param {CSSObject} styles - The styles that should be applied at the given breakpoint.
 * @return {Interpolation}
 */
export var mediaMixin = function mediaMixin(breakpoint, styles) {
  return function (mediaProps) {
    return css(["@media ", "{", "}"], mediaBreakpointMixin(breakpoint), typeof styles === 'function' ? styles(mediaProps) : styles);
  };
};